export const FIELD_NAMES = {
  presupuesto: 'presupuesto',
  tipoConcepto: 'tipoConcepto',
  concepto: 'concepto',
  fecha: 'fecha',
  monto: 'monto',
  detalle: 'detalle',
  comprobante: 'comprobante',
};

export const REQUIRED_FIELDS = [
  { name: FIELD_NAMES.presupuesto, message: 'Selecciona un presupuesto' },
  { name: FIELD_NAMES.tipoConcepto, message: 'Selecciona un tipo de concepto' },
  { name: FIELD_NAMES.concepto, message: 'Selecciona un concepto' },
  { name: FIELD_NAMES.fecha, message: 'Indica la fecha de la transacción' },
  { name: FIELD_NAMES.monto, message: 'Ingresa el monto' },
  { name: FIELD_NAMES.comprobante, message: 'Adjunta el comprobante' },
];

export function validateTransaction(values) {
  const errors = {};
  for (const field of REQUIRED_FIELDS) {
    const value = values[field.name];
    const isEmpty =
      value === '' ||
      value === null ||
      value === undefined ||
      (field.name === FIELD_NAMES.comprobante && !value);
    if (isEmpty) {
      errors[field.name] = field.message;
    }
  }

  const montoNumber = Number(values.monto);
  if (values.monto !== '' && (Number.isNaN(montoNumber) || montoNumber <= 0)) {
    errors.monto = 'El monto debe ser mayor a 0';
  }

  return errors;
}